import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";
import { motion } from "framer-motion";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: "About Us", path: "/about" },
      { name: "Partners", path: "/partners" },
      { name: "Contact", path: "/contact" },
    ],
    // solutions: [
    //   { name: 'SOC', path: '/solutions#soc' },
    //   { name: 'PAM', path: '/solutions#pam' },
    //   { name: 'CIAM', path: '/solutions#ciam' },
    //   { name: 'Network Security', path: '/solutions#network' },
    // ],
    // services: [
    //   { name: 'Managed Security', path: '/services' },
    //   { name: 'Advisory', path: '/advisory' },
    //   { name: 'Compliance', path: '/advisory#compliance' },
    //   { name: 'Training', path: '/advisory#training' },
    // ],
  };

  return (
    <footer className="bg-warm-gray-900 text-white" data-testid="footer">
      <div className="container-custom py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 md:gap-12 text-center md:text-left">
          {/* Left Section */}
          <div className="flex flex-col items-center md:items-start md:w-[50%]">
            <p className="text-warm-gray-300 mb-6 leading-relaxed w-[80%] md:w-[70%]">
              Leading Value Added Distributor for cybersecurity solutions,
              managed services, and compliance advisory in the Middle East.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href="tel:+966554002958"
                className="flex items-center justify-center md:justify-start space-x-2 text-warm-gray-300 hover:text-brand-maroon transition-smooth"
              >
                <Phone className="w-4 h-4" />
                <span>+966 554 002 958</span>
              </a>
              <a
                href="mailto:sales@gulfdigital-me.com"
                className="flex items-center justify-center md:justify-start space-x-2 text-warm-gray-300 hover:text-brand-maroon transition-smooth"
              >
                <Mail className="w-4 h-4" />
                <span>sales@gulfdigital-me.com</span>
              </a>
            </div>

            {/* Social Links */}
            <div className="flex justify-center md:justify-start space-x-4 mt-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-warm-gray-800 hover:bg-brand-maroon transition-smooth"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              {/* <a
        href="https://twitter.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-lg bg-warm-gray-800 hover:bg-brand-maroon transition-smooth"
        aria-label="Twitter"
      >
        <Twitter className="w-5 h-5" />
      </a> */}
              {/* <a
        href="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-lg bg-warm-gray-800 hover:bg-brand-maroon transition-smooth"
        aria-label="Facebook"
      >
        <Facebook className="w-5 h-5" />
      </a> */}
            </div>
          </div>

          {/* Right: Company Links */}
          <div className="md:pl-8 flex flex-col items-center md:items-end">
            <h3 className="font-bold text-warm-gray-300 text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-warm-gray-300 hover:text-brand-maroon transition-smooth"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-warm-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-warm-gray-400 text-sm">
            © {currentYear} Gulf Digital Establishment. All rights reserved.
          </p>
          {/* <div className="flex space-x-6 text-sm">
            <Link
              to="/privacy"
              className="text-warm-gray-400 hover:text-brand-maroon transition-smooth"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-warm-gray-400 hover:text-brand-maroon transition-smooth"
            >
              Terms of Service
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
